import blackFridayTicker from "./ab-tests/black-friday-ticker";
import cookieBar from "./ab-tests/cookie-bar";
import shippingOptionsPlugin from "./ab-tests/shippingOptionsPlugin";
import cartRedesign from "./ab-tests/cartRedesign";
import shippingOptionsInformation from "./ab-tests/shippingOptionsInformation";

import { getCookie, setCookie } from "./helpers/cookie";
import getUrlParameter from "./helpers/getUrlParameter";

const handleAbTests = () => {
	/**
	 * ABTest configuration
	 */
	const ABTests = {};

	// check for fixed test e.g.:
	// - https://loveli.care/?fixed_test=shippingOptionsPlugin_0
	// - https://loveli.care/?fixed_test=shippingOptionsPlugin_1
	const fixedTest = getUrlParameter("fixed_test");
	if (fixedTest) {
		const [testKey, ABVersion] = fixedTest.split("_");
		setCookie(testKey, ABVersion + "", 1);
	}

	// check planned tests
	for (const testKey in ABTests) {
		const ABTest = ABTests[testKey];
		const amountOfVersionsInTest = ABTest.tests.length;

		if (!ABTest.canBeEnabled()) continue;

		let ABVersion = getCookie(testKey);

		if (ABVersion === null) {
			// Calculate total weight
			let totalWeight = 0;
			for (let i = 0; i < amountOfVersionsInTest; i++) {
				totalWeight += ABTest.tests[i].weight;
			}

			// Generate a random number based on total weight
			let randomWeightedIndex = Math.random() * totalWeight;

			// Find which version the random number corresponds to
			let accumulatedWeight = 0;

			for (let i = 0; i < amountOfVersionsInTest; i++) {
				accumulatedWeight += ABTest.tests[i].weight;
				if (randomWeightedIndex < accumulatedWeight) {
					ABVersion = i;
					break;
				}
			}

			setCookie(testKey, ABVersion + "", 90);
		}

		// execute the test
		ABTests[testKey].tests[ABVersion].run();

		// construct GTM payload
		if (!ABTests[testKey].tests[ABVersion].shouldLog()) return;

		const dataLayer = window.dataLayer || [];

		dataLayer.push({
			event: "ab test active",
			ab_test_name: testKey,
			ab_test_variant: String.fromCharCode(1 + Number(ABVersion) + 64), // Create a human readable name
			ab_test_variant_description: ABTests[testKey].tests[ABVersion].description,
			eventNonInteraction: 1,
		});

		// Construct Hotjar Payload
		window.hj =
			window.hj ||
			function () {
				(hj.q = hj.q || []).push(arguments);
			};

		window.hj("identify", null, {
			cartRedesign_ab_test_Version: String.fromCharCode(1 + Number(ABVersion) + 64),
		});
	}
};

handleAbTests();
